export default "/images/smart_contracts_development/importance_of_auditing_nfts.png";